import { Notification, NotificationKey } from 'models';

enum NotificationPriority {
    HIGH = 1,
    NORMAL = 2,
    LOW = 3,
}

enum InboxSort {
    PRIORITY = 'priority',
    LATEST = 'latest',
}

const READ_RANK = 4;

const PRIORITY_BY_TYPE: Record<NotificationKey, NotificationPriority> = {
    [NotificationKey.DIAGRAM_CHAT_MESSAGE]: NotificationPriority.HIGH,
    [NotificationKey.INTERCOM_MESSAGE]: NotificationPriority.HIGH,
    [NotificationKey.DIAGRAM_CHAT_REACTION]: NotificationPriority.LOW,
    [NotificationKey.INTERCOM_REACTION]: NotificationPriority.LOW,
    [NotificationKey.ORDER_MESSAGE]: NotificationPriority.HIGH,
    [NotificationKey.DIAGRAM_COMMENT_CREATE]: NotificationPriority.HIGH,
    [NotificationKey.DIAGRAM_COMMENT_REPLY_USER]: NotificationPriority.HIGH,
    [NotificationKey.DIAGRAM_COMMENT_REPLY_AI]: NotificationPriority.LOW,
    [NotificationKey.DIAGRAM_COMMENT_MENTION_USER]: NotificationPriority.HIGH,
    [NotificationKey.DIAGRAM_COMMENT_MENTION_MANUFACTURER]: NotificationPriority.HIGH,
    [NotificationKey.DIAGRAM_REQUESTACCESS]: NotificationPriority.HIGH,
    [NotificationKey.COMPANY_REQUEST_ACCESS]: NotificationPriority.HIGH,
    [NotificationKey.TEAM_REQUEST_ACCESS]: NotificationPriority.HIGH,
    [NotificationKey.DIAGRAM_INVITE]: NotificationPriority.NORMAL,
    [NotificationKey.USER_TEAM_INVITE]: NotificationPriority.NORMAL,
    [NotificationKey.COMPANY_GRANT_ACCESS]: NotificationPriority.LOW,
    [NotificationKey.COMPANY_DENY_ACCESS]: NotificationPriority.LOW,
    [NotificationKey.TEAM_GRANT_ACCESS]: NotificationPriority.LOW,
    [NotificationKey.TEAM_DENY_ACCESS]: NotificationPriority.LOW,
    [NotificationKey.DIAGRAM_CHAT_CHANNEL]: NotificationPriority.NORMAL,
    [NotificationKey.COMPANY_ADDED_AS_PARTNER]: NotificationPriority.LOW,
    [NotificationKey.COMPANY_NEW_EXHIBITOR_MATCH_LEAD]: NotificationPriority.HIGH,
    [NotificationKey.COMPANY_NEW_QR_SCAN]: NotificationPriority.NORMAL,
    [NotificationKey.DIAGRAM_CHAT_CREDITS_ESTIMATE]: NotificationPriority.HIGH,
    [NotificationKey.DIAGRAM_CHAT_CREDITS_ACCEPT]: NotificationPriority.HIGH,
    [NotificationKey.DIAGRAM_CHAT_CREDITS_DECLINE]: NotificationPriority.NORMAL,
    [NotificationKey.DIAGRAM_CHAT_CREDITS_CHARGE]: NotificationPriority.NORMAL,
    [NotificationKey.ORDER_EVENT]: NotificationPriority.NORMAL,
    [NotificationKey.DESIGN_DUPLICATE]: NotificationPriority.LOW,
};

const NotificationPriorityHelpers = {
    readRank: READ_RANK,

    getPriority: (type: string) => PRIORITY_BY_TYPE[type as NotificationKey] ?? NotificationPriority.LOW,

    getRank: (
        { type, readAt, handledAt }: Pick<Notification, 'type' | 'readAt' | 'handledAt'>,
        sort: InboxSort = InboxSort.PRIORITY,
    ) => {
        if (sort === InboxSort.LATEST) {
            return NotificationPriority.HIGH;
        }

        if (readAt || handledAt) {
            return READ_RANK;
        }

        return NotificationPriorityHelpers.getPriority(type);
    },
};

export { InboxSort, NotificationPriority, NotificationPriorityHelpers };
